export enum InternalValuationTab {
  ALL_LOANS = 'ALL_LOANS',
  IV_PROGRAM = "IV_PROGRAM",
  POST_CLOSING = 'POST_CLOSING',
  INTERNAL_VALUATION = 'INTERNAL_VALUATION',
  DISPUTE_SECOND_APPRAISAL = 'DISPUTE_SECOND_APPRAISAL',
  RENTAL_RISK_PROFILER_REVIEW = 'RENTAL_RISK_PROFILER_REVIEW',
  DISPUTE_APPRAISAL = 'DISPUTE_APPRAISAL',
}

export type InternalValuationLoan = {
  priority: number,
  loanId: number;
  address: string,
  city: string,
  state: string,
  county: string,
  transactionType: string,
  valuationReviewer?: string,
  underwriter?: string,
  appraiserName?: string,
  status: string,
  subStatus: string,
  reason: string,
  queueStartDate?: string,
  appraisalDate?: string,
  appraisalPaidDate?: string,
  inUnderwritingDate?: string,
  loanSubtype: string,
  lenderName?: string,
  amount: string;
  afterRepairValue?: string;
  delay: string;
  delayHour: number;
};